import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import PinField from '../../../../../components/global/PinField';
import { formatPhone } from '../../../../../util/phone';
import CustomControl from '../../../../../components/global/CustomControl';

const propTypes = {
  values: PropTypes.shape({
    phone_number: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
  requireHumanInput: PropTypes.bool,
  blockLogin: PropTypes.bool,
};

const PinVerificationStep = ({
  values,
  loading,
  handleSubmit,
  handleChange,
  onPinCodeResend,
  requireHumanInput,
  blockLogin,
}) => {
  const isValid = values.code?.length === 4;

  return (
    <Fragment>
      <h4 className="px-2">
        Please enter the code sent to: <br />
        <span className="text-primary">
          {formatPhone(values.phone_number)}
        </span>{' '}
      </h4>
      <form onSubmit={handleSubmit} className="px-2">
        <div className="mb-2">
          <PinField
            autofocus
            className="registration-pin-field marketing-account-matches-pin-input"
            onComplete={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>
        {requireHumanInput && (
          <div>
            <CustomControl
              type="checkbox"
              label="I'm not a robot"
              checked={values.force_allow_action}
              onChange={() =>
                handleChange({
                  target: {
                    name: 'force_allow_action',
                    value: !values.force_allow_action,
                  },
                })
              }
            />
          </div>
        )}

        <div>
          <Button
            type="submit"
            disabled={
              loading ||
              !isValid ||
              blockLogin ||
              (requireHumanInput && !values.force_allow_action)
            }
            loading={loading}
            className="d-block mt-2"
          >
            {loading ? 'Processing...' : 'Verify Pin Code'}
          </Button>

          <Button
            type="button"
            btnStyle="link"
            disabled={loading}
            loading={loading}
            className="d-block mt-2"
            onClick={() => onPinCodeResend(values)}
          >
            Re&ndash;send code
          </Button>
        </div>
      </form>
    </Fragment>
  );
};

PinVerificationStep.propTypes = propTypes;

export default PinVerificationStep;
